import { useMemo, useRef } from 'react';
import { Select } from 'antd';
import { useTranslate } from '@tolgee/react';
import { useNotificationSound, useSetNotificationSound } from 'hooks/useNotificationSound';
import { Sound, SoundRef } from 'components/Notification/Sound';

import { ReactComponent as SoundPlayIcon } from '../assets/soundPlay.svg';

export const SoundRemindSelect = () => {
  const ref = useRef<SoundRef | null>(null);
  const notificationSound = useNotificationSound();
  const setNotificationSound = useSetNotificationSound();
  const { t } = useTranslate();

  const options = useMemo(
    () => [
      {
        label: t('ViewSystem.sound1'),
        value: 'sound1',
      },
      {
        label: t('ViewSystem.sound2'),
        value: 'sound2',
      },
      {
        label: t('ViewSystem.sound3'),
        value: 'sound3',
      },
      {
        label: t('ViewSystem.sound4'),
        value: 'sound4',
      },
      {
        label: t('ViewSystem.sound5'),
        value: 'sound5',
      },
      {
        label: t('ViewSystem.sound6'),
        value: 'sound6',
      },
      {
        label: t('ViewSystem.sound7'),
        value: 'sound7',
      },
      {
        label: t('ViewSystem.sound8'),
        value: 'sound8',
      },
      {
        label: t('ViewSystem.sound9'),
        value: 'sound9',
      },
      {
        label: t('ViewSystem.sound10'),
        value: 'sound10',
      },
    ],
    [t],
  );

  return (
    <>
      <div className="flex items-center gap-2">
        <Select value={notificationSound} options={options} onChange={setNotificationSound} />

        <SoundPlayIcon
          width={22}
          height={22}
          onClick={() => {
            ref?.current?.play();
          }}
        />
      </div>
      <Sound ref={ref} />
    </>
  );
};
